import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';

function ExpenseIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
    const [name, setName] = useState("");
    const [Remarks, setRemarks] = useState("");
    const [type, setType] = useState("Expense");

    const history = useHistory();
    const { isAuthenticated, companyId, branchId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('ExpenseHeadApi', `/${companyId}/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching Item:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('ExpenseHeadApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {

                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ExpenseHeadApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemID) => {
        setDeleteItemId(itemID);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addRecord = async (e) => {
        e.preventDefault();

        const CreateData = {
            Name: name,
            Remarks: Remarks,
            IsExpenseOrIncome: type === '1', // Convert '1' to true and '0' to false
            CreatedBy: userId,
            CompanyId: companyId,
            BranchId: branchId,
            CreatedDate: new Date(),
        };

        postData('ExpenseHeadApi', CreateData, token)
            .then((response) => {
                console.log('ExpenseHead Created success:', response);
                setSuccessMessage("ExpenseHead Created successfully!");
                setErrorMessage("");
                setName('');
                setIsModalOpen(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('ExpenseHeadApi', `/ExpenseDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Slab Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
            UpdatedBy: userId,
        }));
    };

    const [updatedData, setUpdateData] = useState({});


    const updateRecord = async (event) => {
        event.preventDefault();

        try {

            await updateData('ExpenseHeadApi', `${updatedData.ID}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
                Remarks: '',
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>ExpenseHead Create

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '170px' : '140px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginLeft: '10px'
                        }}
                    />
                </h6>
                {hasCreateMasterPermission && (
                    <Tooltip title="Create Expense Head">
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #16423C,#6A9C89)',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '5px'
                            }}
                            onClick={toggleModal}
                        >
                            Add
                        </Button>
                    </Tooltip>
                )}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px' }}>
                        <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>ExpenseHead CREATE</h6>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Remarks"
                                    placeholder="Enter Remarks"
                                    value={Remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Type
                                </label>
                                <div className="flex items-center">
                                    <input
                                        type="radio"
                                        id="expense"
                                        name="type"
                                        value="1"
                                        checked={type === '1'}
                                        onChange={(e) => setType(e.target.value)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="expense" className="mr-4">Expense</label>
                                    <input
                                        type="radio"
                                        id="income"
                                        name="type"
                                        value="0"
                                        checked={type === '0'}
                                        onChange={(e) => setType(e.target.value)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="income">Income</label>
                                </div>
                            </div>
                        </div>

                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'hidden' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#C1BAA1' }}>

                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px' }}>Remarks</TableCell>
                                <TableCell sx={{ backgroundColor: '#ECEBDE', borderBottom: '1px solid #F5F5F5', color: 'darkred', fontWeight: 'bolder', padding: '5px', textAlign: 'right' }}></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.map((item, index) => (
                                <TableRow
                                    key={index}
                                    className="border-b"
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                        borderBottom: '1px solid #E0E0E0',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        overflow: 'hidden',
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#E1F0DA')} // Light wave color
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#F7FAFF' : '#FFFFFF')} // Reset color on hover out
                                >
                                    {/* Table cells */}
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '1px',
                                            textAlign: 'left',
                                            width: '65px',
                                        }}
                                    >
                                        {index + 1}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',

                                        }}
                                    >
                                        {item.Name}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',

                                        }}
                                    >
                                        {item.Remarks}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            padding: '3px',
                                            textAlign: 'right'
                                        }}
                                    >
                                        {hasEditMasterPermission && (
                                            <IconButton onClick={() => openDetailModal(item.ID)}>
                                                <EditIcon style={{ color: 'blueviolet' }} />
                                            </IconButton>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => openConfirmDialog(item.ID)}>
                                                <DeleteIcon style={{ color: 'brown' }} />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px' }}>
                            <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>ExpenseHead EDIT</h6>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="Name"
                                        placeholder="Enter name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}

                                    />
                                </div>
                                <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Remarks">
                                        Remarks
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="Remarks"
                                        placeholder="Enter Remarks"
                                        value={updatedData.Remarks}
                                        onChange={handleUpdateInputChange}

                                    />
                                </div>
                            </div>

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                    Add Record
                                </button>
                                <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalBranch}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ExpenseIndex;
